import { styled } from '@mui/material';
import { Typography } from 'core/common/ui/ui-kit';

export const NumberWrapperStyled = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TimerWrapperStyled = styled('div')`
  display: flex;
  align-items: flex-start;
`;

export const TimerLabelStyled = styled(Typography)`
  margin-top: -5px;
`;

export const TimerDividerStyled = styled(Typography)`
  margin-right: 4px;
  margin-left: 4px;
`;
